module.exports = "https://media.zlongame.com/media/pictures/cn/vipCenter/assets/img/m/public/integral/add.png";